import translate from "../../../global/directives/translate";
import {
  FilterDateMixin,
} from "../../../global/mixins/FiltersMixin";

// @vue/component
export default {
  name: "ReleaseNotesModalElement",
  directives: {
    translate,
  },
  mixins: [
    FilterDateMixin,
  ],
  props: {
    note: {
      type: Object,
      required: true,
      info: "Hauptinformation",
    },
  },
  computed: {
    vinDatum() {
      return this.filterDate(this.note.vin_datum);
    },
  },
};
